module.exports = __webpack_public_path__ + "media/images/home-banners/bloom-1839679_1920-cb045522ab99a6d924d4da822d72af44.jpg";